import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";


const ActivitySocketListener = ({ token, userId }) => {
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token || !userId) return;

    // Connect to WebSocket (adjust the URL if your backend host differs)
    socketRef.current = new WebSocket(`ws://127.0.0.1:8000/ws/notifications/${userId}/`);

    socketRef.current.onopen = () => {
      console.log("✅ Connected to notification WebSocket");
    };

    socketRef.current.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        const { event_type, message, user } = data;

        const icon =
          event_type === "Follow-up"
            ? "📋"
            : event_type === "Task"
            ? "✅"
            : "🔔";

        toast.info(`${icon} ${user} added a new ${event_type}: ${message}`, {
          autoClose: 4000,
        });

        // Optional: trigger Navbar to reload notifications
        window.dispatchEvent(new Event("refreshNotifications"));
      } catch (err) {
        console.error("Error parsing WebSocket message:", err);
      }
    };

    socketRef.current.onclose = () => console.log("🔌 Notification socket closed");
    socketRef.current.onerror = (err) => console.error("❌ Socket error:", err);

    return () => {
      socketRef.current.close();
    };
  }, [token, userId]);

  return null; // this component renders nothing
};

export default ActivitySocketListener;
